<div class="modal fade remove-modal" id="downloadingErrorModal" tabindex="-1" role="dialog"
  aria-labelledby="downloadingErrorModalTitleForDownloaded removeDownloadModalTitleForInProcess" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="downloadingErrorModalTitleForDownloaded">
          <img class="exclamation" src="{{imageBasePath}}assets/svg/Red Warning.svg" alt="">
          {{'FOC.DESKTOP.DOWNLOADING_ERROR_MODAL.HEADING' | translate}}
        </h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" #closeModal>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="description">{{'FOC.DESKTOP.DOWNLOADING_ERROR_MODAL.DESC' | translate:{bookName: eBookName} }}</div>
      </div>
      <div class="modal-footer d-flex flex-column">
        <button type="button" class="btn btn-purple" data-dismiss="modal">
          <span>{{'FOC.DESKTOP.DOWNLOADING_ERROR_MODAL.OK' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>